// cookieUtils.ts

// Function to get the main domain dynamically
function getMainDomain(): string {
  const domain = import.meta.env.VITE_APP_DOMAIN_NAME;
  if (!domain) {
    throw new Error("Domain name is not specified in the environment variables.");
  }
  return domain;
}

// Function to set a cookie
function setCookie(name: string, value: string, days: number): void {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000); // Expiration time in milliseconds
  const domain = getMainDomain();

  // Set the cookie
  document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/; domain=${domain}`;
}

// Function to get a cookie by name
function getCookie(name: string): string | null {
  const cookieString = `; ${document.cookie}`;
  const parts = cookieString.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(";").shift() ?? null;
  }
  return null;
}

// Function to remove a cookie
function removeCookie(name: string): void {
  const expires = new Date(0); // Set expiration to the past to delete the cookie
  const domain = getMainDomain();
  document.cookie = `${name}=; expires=${expires.toUTCString()}; path=/; domain=${domain}`;
}

// Export the functions
export { setCookie, getCookie, removeCookie };
